import Vue from "vue";
import "./utilities/initDatadog";

import App from "./App.vue";
// Vuetify UI
import Vuetify from "vuetify/lib";
import "vuetify/dist/vuetify.min.css";
import "@mdi/font/css/materialdesignicons.css";
// Vue function API to use Vue 3.0 features
import "./framework/plugins/vue-function-api";
// Vue Router
import router from "./router/router";
// Vuex Storage
import store from "./store";
// Service Worker for PWA
import "./registerServiceWorker";
// Internationalization i18n
import { i18n } from "./framework/plugins/i18n";
import { Trans } from "./framework/plugins/translation";
// Layouts
import Default from "./framework/layouts/Default.vue";
import NoBottomNav from "./framework/layouts/NoBottomNav.vue";
import NoBackNoBottom from "./framework/layouts/NoBackNoBottom.vue";
import BackNoBottom from "./framework/layouts/BackNoBottom.vue";
import NoHeader from "./framework/layouts/NoHeader.vue";
import NotificationLayout from "./framework/layouts/NotificationLayout.vue";
import HotelAdmin from "./views/admin/HotelAdmin.vue";
import PinchZoom from "vue-pinch-zoom";
import "./framework/assets/style/global.css";
import { formatDate } from "@/framework/utilities/formatDate";
import VueLazyload from "vue-lazyload";
import "./RTLSupport.css";

Vue.component("default-layout", Default);
Vue.component("no-bottom-nav-layout", NoBottomNav);
Vue.component("no-back-no-bottom-layout", NoBackNoBottom);
Vue.component("back-no-bottom-layout", BackNoBottom);
Vue.component("no-header-layout", NoHeader);
Vue.component("staff-notification-layout", NotificationLayout);
Vue.component("hotel-admin-layout", HotelAdmin);
Vue.component("pinch-zoom", PinchZoom);

Vue.config.productionTip = false;
// Customized Vuetify
const opts = {};
Vue.use(Vuetify);

// MomentJS to cusomized & localize dates
Vue.use(require("vue-moment"));

var VueTouch = require("vue-touch");
Vue.use(VueTouch, { name: "v-touch" });

Vue.use(VueLazyload, {
  loading: "/img/loading/ajax-loader.gif", // ロード中に表示する画像指定
  attempt: 1, // ロード失敗した時のリトライの上限指定
});

// Add internationalization i18n to the Vue instance
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans);

Vue.filter("messageTime", function (value: any) {
  if (!value) return "";

  const data = new Date(value);
  const now = new Date();
  if (
    data.getFullYear() === now.getFullYear() &&
    data.getMonth() === now.getMonth() &&
    data.getDate() === now.getDate()
  ) {
    return formatDate(data, "hh:mm");
  } else if (data.getFullYear() === now.getFullYear()) {
    return formatDate(data, "MM/DD hh:mm");
  } else {
    return formatDate(data, "YYYY/MM/DD hh:mm");
  }
});

Vue.filter("quickReplyFilter", function (value: string) {
  if (!value) return "";
  if (value.length > 15) {
    return value.substr(0, 15) + "...";
  } else {
    return value;
  }
});

new Vue({
  router,
  i18n,
  store,
  vuetify: new Vuetify(opts),
  render: (h) => h(App),
}).$mount("#app");
